import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";

import {
  CreateMeasurementPreset,
  CreateMeasurementPresetFailure,
  CreateMeasurementPresetSuccess,
  DeleteAllMeasurementPresets,
  DeleteAllMeasurementPresetsFailure,
  DeleteAllMeasurementPresetsSuccess,
  DeleteMeasurementPreset,
  DeleteMeasurementPresetFailure,
  DeleteMeasurementPresetSuccess,
  LoadMeasurementPresets,
  LoadMeasurementPresetsFailure,
  LoadMeasurementPresetsSuccess,
  MeasurementPresetActionTypes
} from "./measurement-preset.actions";
import { MeasurementPresetApiService } from "../services/measurement-preset-api.service";

@Injectable()
export class MeasurementPresetEffects {
  loadMeasurementPresets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementPresetActionTypes.LOAD_MEASUREMENT_PRESETS),
      switchMap((action: LoadMeasurementPresets) =>
        this.measurementPresetApiService.getMeasurementPresets(action.payload.userId).pipe(
          map(presets => new LoadMeasurementPresetsSuccess({ presets })),
          catchError(error => of(new LoadMeasurementPresetsFailure({ error })))
        )
      )
    )
  );

  createMeasurementPreset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementPresetActionTypes.CREATE_MEASUREMENT_PRESET),
      mergeMap((action: CreateMeasurementPreset) => {
        return this.measurementPresetApiService.createMeasurementPreset(action.payload.preset).pipe(
          map(preset => {
            return new CreateMeasurementPresetSuccess({ preset });
          }),
          catchError(error => {
            console.error("MeasurementPresetEffects: API call failed:", error);
            return of(new CreateMeasurementPresetFailure({ error }));
          })
        );
      })
    )
  );

  deleteMeasurementPreset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementPresetActionTypes.DELETE_MEASUREMENT_PRESET),
      mergeMap((action: DeleteMeasurementPreset) =>
        this.measurementPresetApiService.deleteMeasurementPreset(action.payload.presetId).pipe(
          map(() => new DeleteMeasurementPresetSuccess({ presetId: action.payload.presetId })),
          catchError(error => of(new DeleteMeasurementPresetFailure({ error })))
        )
      )
    )
  );

  deleteAllMeasurementPresets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementPresetActionTypes.DELETE_ALL_MEASUREMENT_PRESETS),
      mergeMap((action: DeleteAllMeasurementPresets) =>
        this.measurementPresetApiService.deleteAllMeasurementPresets(action.payload.userId).pipe(
          map(() => new DeleteAllMeasurementPresetsSuccess()),
          catchError(error => of(new DeleteAllMeasurementPresetsFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private measurementPresetApiService: MeasurementPresetApiService
  ) {}
}
